import { createAction } from 'redux-act'
import API from 'api'

export const couponValidationRequested = createAction('coupon/validationRequested')
export const couponCodeValidated = createAction('coupon/couponCodeValidated')

export const validateCouponCodeAction = () => (dispatch, getState) => {
  const { reservation } = getState()

  if (!reservation.data.coupon_code) {
    dispatch(couponCodeValidated({}))
    return Promise.resolve()
  }

  const { data, id } = reservation
  const { coupon_code } = data
  dispatch(couponValidationRequested({ coupon_code }))

  return API.validateCoupon(coupon_code, id)
    .then((response) => {
      dispatch(couponCodeValidated(response))
      return Promise.resolve()
    })
    .catch((response) => {
      dispatch(couponCodeValidated(response))
      return Promise.resolve()
    })
}
